import React from 'react'
import MaterialSymbol from '../material-symbol'

const Build = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="build" {...props} />
))

Build.displayName = 'Build'

export default Build
